module.exports = __webpack_public_path__ + "img/meituan.f2e8c068.png";